import { addDays, getMonth, getYear } from 'date-fns';
import { fromZonedTime, toZonedTime } from 'date-fns-tz';

export interface MarketReactionDates {
  fromDateUTC: Date;
  toDateUTC: Date;
}

export const useMarketReactionDates = (
  reportingDate: string
): MarketReactionDates => {
  const reportingDateET = toZonedTime(reportingDate, 'America/New_York');

  const reportingDayET = parseInt(
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      day: 'numeric',
    }).format(reportingDateET)
  );

  const fromDate = addDays(
    new Date(
      getYear(reportingDateET),
      getMonth(reportingDateET),
      reportingDayET,
      9,
      30,
      0,
      0
    ),
    -4
  );

  const fromDateUTC = fromZonedTime(fromDate, 'America/New_York');

  const toDate = addDays(
    new Date(
      getYear(reportingDateET),
      getMonth(reportingDateET),
      reportingDayET,
      16,
      0,
      0,
      0
    ),
    4
  );

  const toDateUTC = fromZonedTime(toDate, 'America/New_York');

  return { fromDateUTC, toDateUTC };
};
